
/**
 * Scroll Action base class
 *
 * Will detect specific actions on scroll
 */
export default class ScrollAction {


    /**
     * constructor
     *
     * @param  {Element} element
     * @param  {Object} props
     * @return {Void}
     */
    constructor (element, props) {
        this.element = element;

        this.hijackMode = props.hijackMode;
        this.horizontalDistance = props.horizontalDistance || false;
        this.slowScroll = props.slowScroll;
        this.safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        this.deltaY = 0;
        this.touchY = -1;

        this.getElementTopOffset();

        if (!this.hijackMode) {
            this.calcDelta();
        }

        setInterval(this.getElementTopOffset.bind(this), 1500);

        this.onScrollHijackBind = this.onScrollHijack.bind(this);
        this.onScrollNormalBind = this.onScrollNormal.bind(this);

        this.bindEvents();
    }

    /**
     * Destructor
     *
     * Unbinds scroll events and such
     */
    destructor () {
        const event = this.safari ? 'scroll' : 'wheel';

        if (this.hijackMode) {
            window.removeEventListener(event, this.onScrollHijackBind);
            window.removeEventListener('touchmove', this.onScrollHijackBind);
        } else {
            window.removeEventListener('scroll', this.onScrollNormalBind);
        }
    }

    /**
     * bindEvents - Bind DOM events
     *
     * @return {Void}
     */
    bindEvents () {
        const event = this.safari ? 'scroll' : 'wheel';

        if (this.hijackMode) {
            window.addEventListener(event, this.onScrollHijackBind);
            window.addEventListener('touchmove', this.onScrollHijackBind);
        } else {
            window.addEventListener('scroll', this.onScrollNormalBind);
        }

        window.addEventListener('resize', () => {
            this.getElementTopOffset();

            if (!this.hijackMode) {
                this.calcDelta();
            }
        });
    }

    /**
     * getElementTopOffset - Gets top offset of element
     *
     * @return {Void}
     */
    getElementTopOffset () {
        let offset = 0;
        let scrollPos = window.scrollY ? window.scrollY : window.pageYOffset;

        offset = this.element.getBoundingClientRect().top;
        offset += scrollPos;

        this.elementOffsetTop = offset;
    }

    /**
     * calcDelta - Calculates delta properties for normal scroll mode
     *
     * @return {Void}
     */
    calcDelta () {
        this.deltaBegin = this.elementOffsetTop - window.innerHeight / 2;
        this.deltaEnd = this.elementOffsetTop// + this.element.offsetHeight;
        this.deltaTotal = this.deltaEnd - this.deltaBegin;
    }

    /**
     * onScrollNormal - When scrolling in normal mode
     *
     * @param  {Event} e
     * @return {Void}
     */
    onScrollNormal (e) {
        const scrollPos = window.scrollY ? window.scrollY : window.pageYOffset;
        const delta = this.deltaTotal - (this.deltaEnd - scrollPos);

        if (scrollPos >= this.deltaBegin &&
            scrollPos <= this.deltaEnd) {

            this.animationCallback((delta / this.deltaTotal).toFixed(4));
        }
    }


    /**
     * animationCallback - Callback which is called during the animation process
     *
     * @param  {type} animationPercentage = 0 percentage of animation between 0.00 and 1.00
     * @return {Void}
     */
    animationCallback (animationPercentage = 0) {
        window.requestAnimationFrame(() => {
            this.element.style.transform = "translateX(" + animationPercentage * window.innerWidth + "px)";
        });
    }


    /**
     * onScrollHijack - When scrolling in hijack mode
     *
     * @param  {Event} e
     * @return {Void}
     */
    onScrollHijack (e) {
        const scrollPos = window.scrollY ? window.scrollY : window.pageYOffset;
        const scrollY = scrollPos + (window.innerHeight * (this.slowScroll ? 0.4 : (this.safari ? 0.2 : 0)));
        const scrollYBottom = scrollPos + (window.innerHeight * (this.slowScroll ? 0.2 : (this.safari ? 0.3 : 0.1)));

        if (e.touches) {
            e.deltaY = 0;

            if (this.touchY > -1) {
                e.deltaY = this.touchY - e.touches[0].pageY;
            }

            this.touchY = e.touches[0].pageY;
        }

        if (this.safari) {
            this.deltaY = Math.max(0, scrollY - this.elementOffsetTop);
        }

        // Really really not proud of this terrible code, but now at the stage
        // that i really dont care anymore. Shitty implementation causes
        // shitty code (and no time)
        let condition = false;

        if (this.slowScroll) {
            condition = scrollY >= this.elementOffsetTop && scrollYBottom <= this.elementOffsetTop;
        } else {
            condition = scrollY >= 0;
        }

        if (condition) {
            const diff = scrollY - scrollYBottom;

            this.deltaY += e.deltaY || 0;

            if (this.deltaY <= 0) {
                this.deltaY = 0;

                this.animationCallback((this.deltaY / this.horizontalDistance).toFixed(4));

                return;
            } else if (this.deltaY >= this.horizontalDistance) {
                this.deltaY = this.horizontalDistance;

                this.animationCallback((this.deltaY / this.horizontalDistance).toFixed(4));

                return;
            }

            if (this.slowScroll === true) {
                this.scrollTo(e, diff);
            }

            e.preventDefault();

            if (this.safari) {
                console.log('per', Math.abs(scrollYBottom - scrollY).toFixed(4));

                return this.animationCallback((this.deltaY / Math.abs(scrollYBottom - scrollY)).toFixed(4));
            }

            this.animationCallback((this.deltaY / this.horizontalDistance).toFixed(4));
        }
    }


    /**
     * scrollTo
     * Set window scroll position
     *
     * @param  {Event} e
     * @param  {type} diff progress of scroll in px
     */
    scrollTo (e, diff) {
        const scrollToPos = (this.elementOffsetTop - window.innerHeight * 0.4) +
                            (diff * (this.deltaY / this.horizontalDistance));
        const scrollPos = window.scrollY ? window.scrollY : window.pageYOffset;

        if (e.deltaY >= 0 && scrollToPos > scrollPos) {
            window.scroll(0, scrollToPos);
        } else if (e.deltaY < 0 && scrollToPos < scrollPos) {
            window.scroll(0, scrollToPos);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/scroll-action.js